import React, { useEffect, useState } from 'react'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import { MDBDataTable } from 'mdbreact'
import { RoomChangeListApi } from '../../ApiFile'
import { Col, Row } from 'react-bootstrap'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MobileNavbarAdmin from './MobileNavbarAdmin'

const RoomChange = () => {
  const navigate = useNavigate()

  const [data, setData] = useState({
    columns: [
      {
        label: 'Serial No',
        field: 'serial_no',
        sort: 'asc',
      },
      {
        label: 'Member ID',
        field: 'member_id',
        sort: 'asc',
      },
      {
        label: 'Name',
        field: 'name',
        sort: 'asc',
      },
      {
        label: 'Block ID',
        field: 'block_id',
        sort: 'asc',
      },
      {
        label: 'Room ID',
        field: 'room_id',
        sort: 'asc',
      },
      {
        label: 'Bed ID',
        field: 'bed_id',
        sort: 'asc',
      },
      {
        label: 'Receive Amount',
        field: 'receive_amount',
        sort: 'asc',
      },
      {
        label: 'Action',
        field: 'action',
      },
    ],
    rows: [],
  })

  useEffect(() => {
    fetch(RoomChangeListApi)
      .then((response) => response.json())
      .then((data) => {
        const rows = data.map((item, index) => ({
          serial_no: index + 1,
          member_id: item.member_id,
          name: item.name,
          block_id: item.block_id,
          room_id: item.room_id,
          bed_id: item.bed_id,
          receive_amount: item.receive_amount,
          action: (
            // <Button
            //   style={{ backgroundColor: 'Highlight', color: 'whitesmoke' }}
            //   onClick={() => handleChange(item.member_id)}
            // >
            //   Change
            // </Button>
            <Button
              style={{
                backgroundColor: item.flag === 1 ? 'grey' : 'Highlight',
                color: 'whitesmoke',
                cursor: item.flag === 1 ? 'not-allowed' : 'pointer',
              }}
              disabled={item.flag === 1}
              onClick={() => handleChange(item.member_id)}
            >
              Change
            </Button>
          ),
        }))
        setData((prevData) => ({ ...prevData, rows }))
      })
  }, [])

  const handleChange = (member_id) => {
    navigate('/AdminBlock', { state: { MemberId: member_id } })
    // Add your change logic here
  }

  return (
    <>
     <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <NavLogo />

        {/* Mobile navbar for smaller screens */}
        <div className="d-block d-md-none">
          <MobileNavbarAdmin />
        </div>

        <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Room Change
            </h5>
          </div>

          <Row className="m-0 p-0 px-md-3">
            <Col className="m-0 p-0 px-3 py-3 rounded shadow" style={{ background: 'white' }}>
              <div style={{ overflowY: 'auto' }}>
                <div style={{ overflowX: 'auto' }}>
                  <MDBDataTable
                    striped
                    bordered
                    small
                    data={data}
                    className="custom-datatable text-center"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    </>
  )
}

export default RoomChange
